import { render, staticRenderFns } from "./nav-footer.vue?vue&type=template&id=4d9e767e"
import script from "./nav-footer.vue?vue&type=script&lang=js"
export * from "./nav-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports